import FastMarquee from "react-fast-marquee";
import { motion, useReducedMotion } from "framer-motion";
import useScrollVelocitySkew from "../../hooks/useScrollVelocitySkew";
import { useLang } from "../../context/LangContext";
import { c } from "../../content";

const TECH = [
  "React 19", "Framer Motion", "Next.js", "Tailwind CSS",
  "FastAPI", "Supabase", "MongoDB", "Stripe", "Canvas API", "Vercel",
];

function Dot({ dim }) {
  return (
    <span
      aria-hidden="true"
      style={{
        display: "inline-block", width: 3, height: 3, borderRadius: "50%",
        background: dim ? "rgba(242,232,216,0.16)" : "rgba(124,196,216,0.55)",
        margin: "0 2rem", verticalAlign: "middle", flexShrink: 0,
      }}
    />
  );
}

export default function Marquee() {
  const skewX = useScrollVelocitySkew(2.4);
  const { lang } = useLang();
  const METRICS = c.marquee.metrics[lang];
  const prefersReduced = useReducedMotion();

  return (
    <motion.div
      style={{
        skewX, position: "relative", overflow: "hidden",
        background: "rgba(200,121,65,0.055)",
        backdropFilter: "blur(20px)", WebkitBackdropFilter: "blur(20px)",
        borderTop: "1px solid rgba(200,121,65,0.22)",
        borderBottom: "1px solid rgba(200,121,65,0.22)",
        boxShadow: "0 0 60px rgba(200,121,65,0.06), inset 0 1px 0 rgba(200,121,65,0.16), inset 0 -1px 0 rgba(200,121,65,0.08)",
      }}
      data-testid="marquee"
    >
      <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(ellipse 60% 100% at 50% 50%, rgba(200,121,65,0.05), transparent)" }} />
      <div className="pointer-events-none absolute inset-y-0 left-0 w-28 z-10" style={{ background: "linear-gradient(to right, #100F0C 0%, rgba(16,15,12,0) 100%)" }} />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-28 z-10" style={{ background: "linear-gradient(to left, #100F0C 0%, rgba(16,15,12,0) 100%)" }} />

      <div style={{ padding: "14px 0 10px" }}>
        <FastMarquee speed={44} gradient={false} pauseOnHover={false} direction="left" play={!prefersReduced}>
          {TECH.map((item, i) => (
            <span key={i} className="font-display font-light" style={{ fontSize: "clamp(0.68rem, 1.1vw, 0.85rem)", letterSpacing: "0.06em", color: "rgba(242,232,216,0.42)", display: "inline-flex", alignItems: "center" }}>
              {item}<Dot dim />
            </span>
          ))}
        </FastMarquee>
      </div>

      <div aria-hidden="true" style={{ height: 1, background: "linear-gradient(to right, transparent 0%, rgba(200,121,65,0.18) 20%, rgba(200,121,65,0.18) 80%, transparent 100%)", margin: "0 7rem" }} />

      <div style={{ padding: "10px 0 14px" }}>
        <FastMarquee speed={36} gradient={false} pauseOnHover={false} direction="right" play={!prefersReduced}>
          {METRICS.map((item, i) => (
            <span key={i} className="font-mono" style={{ fontSize: "0.65rem", letterSpacing: "0.28em", textTransform: "uppercase", color: "rgba(200,121,65,0.80)", fontWeight: 500, display: "inline-flex", alignItems: "center" }}>
              {item}<Dot />
            </span>
          ))}
        </FastMarquee>
      </div>
    </motion.div>
  );
}
